import React from 'react';
import styled from 'styled-components';
import StackSigma from './StackSigma';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const Container = styled.div`
    border-radius: 1rem;
    padding-block-end: 2rem;
    padding-block-start: 2rem;
    background-color: #121212;
    background-image: url(${process.env.PUBLIC_URL}/img/SigmaVectorExp.svg);
    background-repeat: no-repeat;
    background-position: 90% 85%;
    background-size: 90rem;
    opacity: 0;
    transform: translateY(2.5rem);
    transition: opacity 0.7s cubic-bezier(0.23, 1, 0.32, 1),
        transform 0.7s cubic-bezier(0.23, 1, 0.32, 1);

    &.visible {
        opacity: 1;
        transform: translateY(0);
    }

    h1 {
        margin: 0 0 1rem 0;
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        font-size: clamp(1.6rem, 2.5vw + 0.5rem, 2.75rem);
        font-weight: 900;
    }

    h2 {
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        margin-top: 0;
        font-size: clamp(1rem, 1.5vw + 0.3rem, 1.75rem);
        font-weight: 700;
    }

    p {
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        margin-top: 0;
        font-size: clamp(1rem, 1vw + 0.3rem, 1.3rem);
    }
`;

const ExpSigma = () => {
    const [ref, isVisible] = useScrollAnimation();
    return (
        <Container ref={ref} className={isVisible ? 'visible' : ''}>
            <h1>SIGMA</h1>
            <h2>junior fullstack developer (11.20 – 08.22)</h2>
            <p>
                maintaining the functionality of the "sigma sus" electrical
                network management system
            </p>
            <StackSigma />
        </Container>
    );
};

export default ExpSigma;
